export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-16">
        <div className="grid lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img
              src="https://static.readdy.ai/image/2d70788572f3bf6ab3fc4009e4756eb5/7f9ed3602ae8058bafa044d085fa2086.png"
              alt="AIRPURE"
              className="h-12 w-auto mb-5"
            />
            <p className="text-slate-400 text-sm leading-relaxed mb-6 max-w-sm">
              Votre expert en solutions énergétiques durables. Pompes à chaleur, panneaux solaires, éclairage LED — on vous accompagne de A à Z.
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-facebook-fill', href: '#' },
                { icon: 'ri-instagram-fill', href: '#' },
                { icon: 'ri-linkedin-fill', href: '#' },
              ].map((s, i) => (
                <a key={i} href={s.href} className="w-9 h-9 bg-slate-800 hover:bg-orange-500 rounded-full flex items-center justify-center transition-colors cursor-pointer">
                  <i className={`${s.icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-extrabold text-white mb-5 text-sm uppercase tracking-wider">Navigation</h4>
            <div className="space-y-3">
              {[
                { label: 'Nos Solutions', href: '#solutions' },
                { label: 'Pourquoi AIRPURE', href: '#pourquoi' },
                { label: 'Zone d\'intervention', href: '#zone' },
                { label: 'Contrats d\'entretien', href: '/contrat-entretien' },
                { label: 'Déshumidificateurs', href: '/deshumidificateurs' },
                { label: 'Contact', href: '#contact' },
              ].map((l, i) => (
                <a key={i} href={l.href} className="block text-slate-400 hover:text-white text-sm transition-colors cursor-pointer">
                  {l.label}
                </a>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-extrabold text-white mb-5 text-sm uppercase tracking-wider">Contact</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-phone-line text-orange-400 mt-0.5"></i>
                <div>
                  <p className="text-white font-bold text-sm">01 89 29 33 23</p>
                  <p className="text-slate-500 text-xs">Lun–Ven · 9h–18h</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-orange-400 mt-0.5"></i>
                <p className="text-slate-400 text-sm">contact@air-pure-groupe.fr</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-orange-400 mt-0.5"></i>
                <p className="text-slate-400 text-sm">14 rue du Cadran<br />94220 Charenton-le-Pont</p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">© 2024 AIRPURE. Tous droits réservés.</p>
          <div className="flex flex-wrap gap-5 text-xs text-slate-500">
            {['Mentions légales', 'Confidentialité', 'CGV', 'Plan du site'].map((l, i) => (
              <a key={i} href="#" className="hover:text-white transition-colors cursor-pointer">{l}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
